// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

/* eslint-disable */

/**
 * This is a automatically generated component, do not edit it.
 * If you need to edit this component, move it to some other folder.
 */

import * as React from 'react';
import svg, { path } from 'react-native-svg';
function DrugIcon9(props: React.SVGProps<SVGSVGElement>): React.ReactElement {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={32}
      height={32}
      viewBox="0 0 32 32"
      fill="none"
      {...props}
    >
      <path
        fill="currentColor"
        d="M13.44 9.773V6.546a.333.333 0 1 0-.667 0v3.227a.333.333 0 0 0 .667 0ZM14.554 10.106a.333.333 0 0 0 .333-.333V6.546a.333.333 0 1 0-.666 0v3.227a.333.333 0 0 0 .333.333ZM16 10.106a.334.334 0 0 0 .333-.333V6.546a.333.333 0 1 0-.667 0v3.227a.333.333 0 0 0 .333.333ZM17.447 10.106a.333.333 0 0 0 .333-.333V6.546a.333.333 0 1 0-.667 0v3.227a.333.333 0 0 0 .334.333ZM18.894 10.106a.333.333 0 0 0 .333-.333V6.546a.333.333 0 1 0-.666 0v3.227a.333.333 0 0 0 .333.333Z"
      />
      <path
        fill="currentColor"
        d="m21.037 15.077-1.464-2.107h.284a.333.333 0 1 0 0-.667h-.56a5.374 5.374 0 0 1 0-.706h1.37a.334.334 0 0 0-.024-.667V5.45a.73.73 0 0 0-.626-.72l-1.14-1.257a2.88 2.88 0 0 1-.737-1.92V1.02A1.023 1.023 0 0 0 17.12 0h-2.24a1.023 1.023 0 0 0-1.02 1.02v.533a2.88 2.88 0 0 1-.737 1.92L12 4.73a.73.73 0 0 0-.627.72v5.48a.334.334 0 0 0 0 .667h1.37c.016.235.016.471 0 .706h-.6a.334.334 0 0 0 0 .667h.284l-1.464 2.107A5.334 5.334 0 0 0 10 18.143V29.78A2.223 2.223 0 0 0 12.223 32h7.554A2.223 2.223 0 0 0 22 29.78V18.143a5.334 5.334 0 0 0-.963-3.066ZM13.617 3.92c.585-.65.91-1.492.91-2.367V1.02a.356.356 0 0 1 .353-.353h2.24a.357.357 0 0 1 .353.353v.533c0 .875.325 1.718.91 2.367l.724.8h-6.214l.724-.8Zm-1.594 6.95V5.45a.063.063 0 0 1 .064-.063h7.826a.063.063 0 0 1 .064.063v5.42a.063.063 0 0 1-.064.06h-7.826a.063.063 0 0 1-.064-.06Zm1.354.727h5.246c-.02.235-.02.471 0 .706H13.37c.018-.235.02-.47.007-.706Zm-1.867 3.86c1.69-2.434 1.61-2.3 1.697-2.487h5.586c.1.207.037.093 1.697 2.487.55.788.844 1.726.843 2.686v.73H10.667v-.73c-.001-.96.293-1.898.843-2.686Zm9.823 13.293H10.667v-9.21h10.666v9.21Zm-1.556 2.583h-7.554a1.553 1.553 0 0 1-1.556-1.553v-.363h10.666v.363a1.553 1.553 0 0 1-1.556 1.553Z"
      />
      <path
        fill="currentColor"
        d="M15.74 26.566c.173.017.347.017.52 0 2.204-.15 3.907-2.117 3.98-2.207a.333.333 0 0 0 0-.43c-.073-.086-1.776-2.053-3.98-2.203a2.26 2.26 0 0 0-.52 0c-2.203.15-3.906 2.117-3.98 2.203a.334.334 0 0 0 0 .43c.074.09 1.777 2.057 3.98 2.207Zm-1.506-2.42a1.767 1.767 0 1 1 3.534 0 1.767 1.767 0 0 1-3.534 0Zm3.946 1.073a2.413 2.413 0 0 0 0-2.15c.49.306.944.667 1.35 1.077a7.46 7.46 0 0 1-1.35 1.073Zm-4.36-2.15a2.414 2.414 0 0 0 0 2.15 7.466 7.466 0 0 1-1.35-1.073 7.45 7.45 0 0 1 1.35-1.077Z"
      />
      <path
        fill="currentColor"
        d="M16 22.86a1.287 1.287 0 1 0 0 2.573 1.287 1.287 0 0 0 0-2.574Zm0 1.906a.62.62 0 1 1 0-1.24.62.62 0 0 1 0 1.24Z"
      />
    </svg>
  );
}
export default DrugIcon9;
